(() => {
  if (customElements.get('pb-variant-guidance')) return;

  class PbVariantGuidance extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-variant-guide]'));
      this.onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('product:variant-change', this.onVariantChange);
      const selected = this.dataset.selectedVariant;
      this.show(selected);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
    }

    onVariantChange(event) {
      if (!event.detail?.variant) return;
      this.show(String(event.detail.variant.id));
    }

    show(variantId) {
      this.items.forEach((item) => {
        item.hidden = item.dataset.variantGuide !== variantId;
      });
    }
  }

  customElements.define('pb-variant-guidance', PbVariantGuidance);
})();
